<template>
  <div class="main">
    <div class="swipe">
      <img src="http://123.56.170.62:9999/static/bg/banner4.png" alt />
    </div>
    <div class="program">
      <div class="showSomeProgram">
        <div class="pheader">
          <i class="el-icon-arrow-left"></i>
          <span @click="ret">返回列表</span>
        </div>
        <div class="pLine"></div>
        <div class="pabs">
          <h2>{{ newsData.name }}</h2>
          <h4>
            <span>{{ newsData.magtime }}</span>
            <span>浏览量 : {{ newsData.magcount }}</span>
          </h4>
          <div class="pabsContent" v-html="newsData.magtext"></div>
        </div>
        <div class="rebtn">
          <el-button @click="ret" type="primary">返回列表</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getInfoDetail } from "@/api/news.js"
import Bus from "@/utils/bus.js"
import { BASE_URL } from "@/utils/base.js"
export default {
  name: "Home",
  data() {
    return {
      url: "",
      newsData: {},
    }
  },
  mounted() {
    window.scrollTo({
      top: 0,
    })
    this.getData()
    // this.$nextTick(function() {
    //   if (newsData.vypublic == "活动展示") {
    //     Bus.$emit("getCurrent", "news");
    //   } else {
    //     Bus.$emit("getCurrent", "news");
    //   }
    // });
    // this.$nextTick(()=>{
    //  this.$refs.myVideo.src = "../../assets/demo.mp4";
    // })
  },
  methods: {
    // 获取数据
    async getData() {
      let news = new FormData()
      news.append("sids", this.$route.params.id)
      let data = await getInfoDetail(news)
      this.newsData = data
      this.newsData.magtime = this.newsData.magtime.substring(0, 10)
    },
    // 返回上一页
    ret() {
      this.$router.go(-1)
    },
  },
  components: {},
}
</script>
<style lang="less" scoped>
.main {
  width: 100%;
  .swipe {
    width: 100%;
    img {
      width: 100%;
      height: 400px;
    }
  }
  .program {
    padding-bottom: 42px;
    width: 100%;
    background-color: #fff;
    .showSomeProgram {
      width: 854px;
      margin: 40px auto;
      text-align: center;
      .pheader {
        text-align: left;
        margin: 40px 15px 20px;
        font-size: 16px;
        i {
          color: #ff4040;
          margin-right: 10px;
        }
        span {
          color: #000;
          cursor: pointer;
        }
      }
      .pLine {
        width: 100%;
        height: 2px;
        margin: 0;
        background-color: #f5f5f5;
      }
      .video {
        margin-top: 30px;
        // video::-webkit-media-controls-fullscreen-button {
        //   display: none;
        // }
      }
      .pabs {
        width: 620px;
        margin: 60px auto 0;
        display: flex;
        flex-direction: column;
        font-size: 14px;
        color: #000;
        h2 {
          font-size: 24px;
          color: #000;
          line-height: 1.3;
          text-align: center;
          margin-bottom: 30px;
        }
        .pabsContent {
          line-height: 2;
          text-align: left;
        }
        h4 {
          display: flex;
          margin-bottom: 20px;
          justify-content: flex-end;
          span {
            margin-right: 10px;
          }
        }
      }
      .rebtn {
        margin-top: 60px;
      }
    }
  }
}
</style>
